/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { Form } from 'react-bootstrap'
import { pristyncare } from '../auth/core/_requests'
import { PristynCareModel } from '../auth/core/_models'
import { useAuth } from '../auth/core/Auth'



const city =
  ["Bangalore", "Chennai", "Hyderabad", "Agra", "Ahmedabad", "Bhopal",
    "Bhubaneswar", "Chandigarh", "Coimbatore", "Dehradun", "Delhi", "Faridabad", "Ghaziabad",
    "Gurgaon", "Guwahati", "Gwalior", "Indore", "Jaipur", "Jammu", "Kanpur", "Kochi", "Kolkata",
    "Kozhikode", "Lucknow", "Ludhiana", "Madurai", "Meerut", "Mumbai", "Mysore", "Nagpur", "Nashik", "Noida",
    "Patna", "Pune", "Raipur", "Ranchi", "Siliguri", "Surat", "Thiruvananthapuram", "Vadodara", "Vijayawada", "Visakhapatnam"];

const disease = ["Abortion", "ACL Tear", "Adenoidectomy", "Anal Fissure", 
  "Appendicitis", "Arthroscopy", "Breast Lift", "Carpal Tunnel Syndrome", "Cataract Surgery", "Circumcision",
  "Clitoral Hoodoplasty", "Cystoscopy", "Deep Vein Thrombosis", "Deviated Nasal Septum", "Diabetic Foot Ulcer",
  "ENT Others", "Erectile Dysfunction", "Female Genital Problems", "Female Infertility", "Female Urinary Problems",
  "Gallstones", "Gynecomastia", "Hair Transplant", "Hernia", "Hip Replacement", "Hydrocele", "Hymenoplasty",
  "Hysterectomy", "Hysteroscopy", "Irregular Periods", "IUI", "IVF", "Kidney Stone", "Knee Replacement", "Labiaplasty",
  "Laser Vaginal Rejuvenation", "Laser Vaginal Tightening", "Lasik Surgery", "Lichen Sclerosus", "Lipoma", "Liposuction",
  "Male Infertility", "Male Urinary Tract Infection", "Mastoidectomy ", "Medical Termination Of Pregnancy",
  "Menstrual Disorders", "Microlaryngeal", "Myringotomy", "Ovarian Cyst", "Pain During Intercourse", "Pap Smear",
  "PCOS PCOD", "Pelvic Pain", "Phimosis", "Piles", "Pilonidal Sinus", "Preconception Care", "Pregnancy Care",
  "Prostate Enlargement", "Rectal Prolapse", "Rhinoplasty", "Ruptured Eardrum", "Sebaceous Cyst", "Septoplasty ",
  "Sinusitis", "Spider Veins", "Stress Urinary Incontinence", "Tongue base reduction", "Tonsillitis",
  "Turbinate reductio", "Umbilical Hernia", "Urethral Stricture", "Urinary Incontinence", "Urinary Tract Infection",
  "Uterine Fibroid", "Uvulopalatopharyngoplasty", "Vaginal Cyst", "Vaginal Discharge", "Vaginal Dryness",
  "Vaginal Recurrent Infection", "Vaginoplasty", "Varicocele", "Varicose Veins"];

const registrationSchema = Yup.object().shape({
  firstname: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('First name is required'),
  mobile: Yup.string()
    .min(10, 'Minimum 10 numbers')
    .required('Mobile Number is required'),
  city: Yup.string().required('Time zone is required'),
  disease: Yup.string().required('Disease is required'),
  acceptTerms: Yup.bool().required('You must accept the terms and conditions'),
})

export function PristynCareForm() {
  const initialValues = {
    firstname: useAuth().currentUser?.Name!,
    mobile: '',
    email: '',
    city: '',
    disease: '',
    acceptTerms: false,
  }

  const username = useAuth().currentUser?.UserName!
  const [loading, setLoading] = useState(false)
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        let data: PristynCareModel = {
          Mobile: values.mobile,
          FirstName: values.firstname,
          source: 'Futurisk',
          disease: values.disease,
          City: values.city,
          CrmLoginId: username,
        };        
        alert((await pristyncare(data)).data);
        setLoading(false);
        // submit data
      } catch (error) {
        console.error(error)
        setLoading(false);
      }
    },
  })

  useEffect(() => {
    //PasswordMeterComponent.bootstrap()
  }, [])

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_pristyncare_form'
      onSubmit={formik.handleSubmit}
    >
      {/* begin::Heading */}
      <div className='mb-10 text-center'>
        {/* begin::Title */}
        
        <h1 className='text-dark mb-3 '>Looking for planned hospitalization?  Get free expert consultation from Pristyncare</h1>
        {/* end::Title */}
        

      </div>
      {/* end::Heading */}




      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      {/* begin::Form group Firstname */}
      <div className='fv-row mb-7'>

        <label className='form-label fw-bolder text-dark fs-6'>First Name</label>
        <input
          placeholder='First name'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('firstname')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {
              'is-invalid': formik.touched.firstname && formik.errors.firstname,
            },
            {
              'is-valid': formik.touched.firstname && !formik.errors.firstname,
            }
          )}
        />
        {formik.touched.firstname && formik.errors.firstname && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.firstname}</span>
            </div>
          </div>
        )}


      </div>
      {/* end::Form group */}

      {/* begin::Form group Email */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Mobile</label>
        <input
          placeholder='Mobile'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('mobile')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            { 'is-invalid': formik.touched.mobile && formik.errors.mobile },
            {
              'is-valid': formik.touched.mobile && !formik.errors.mobile,
            }
          )}
        />
        {formik.touched.mobile && formik.errors.mobile && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.mobile}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group city */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>City</label>
        <Form.Select size='lg' className='form-select form-select-solid form-select-lg fw-bold'

          {...formik.getFieldProps('city')}>
          <option value=''>Select City</option>
          {city.map(item => {
            return (<option key={item} value={item}>{item}</option>);
          })}
        </Form.Select>
      </div>
      {/* end : Form group */}

      {/* begin::Form group city */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Medical Procedure</label>
        <Form.Select size='lg' className='form-select form-select-solid form-select-lg fw-bold'

          {...formik.getFieldProps('disease')}>
          <option value=''>Select Procedure</option>
          {disease.map(item => {
            return (<option key={item} value={item}>{item}</option>);
          })}
        </Form.Select>
      </div>
      {/* end : Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='form-check form-check-custom form-check-solid'>
          <input
            className='form-check-input'
            type='checkbox'
            id='kt_login_toc_agree'
            {...formik.getFieldProps('acceptTerms')}
          />
          <label
            className='form-check-label fw-bold text-gray-700 fs-6'
            htmlFor='kt_login_toc_agree'
          >
            I Agree the{' '}
            <Link to='/auth/terms' className='ms-1 link-primary'>
              terms and conditions
            </Link>
            .
          </label>
          {formik.touched.acceptTerms && formik.errors.acceptTerms && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.acceptTerms}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_up_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid || !formik.values.acceptTerms}
        >
          {!loading && <span className='indicator-label'>Book My Appointment</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Form group */}
    </form>
  )
}
